import { useNavigate } from "react-router-dom";
import ProgressBar from "../../../components/progressBar/ProgressBar";
import { Container, Position } from "./PhraseStyles";
import TitleStyles from "../../../components/ui/TitleStyles";
import Description from "../../../components/ui/Description";
import TextArea from "../../../components/ui/TextArea";
import ButtonGroup from "../../../components/ui/ButtonGroup";

const Phrase = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <TitleStyles>Frase</TitleStyles>
      <Description>Adicione uma frase que te represente</Description>
      <TextArea
        placeholder="Crie uma frase que te represente. Exemplo: 'Criando experiências únicas através da música.'"
        rows={6}
      />

      <Position>
        <ProgressBar totalSteps={9} currentStep={5} />
        <ButtonGroup
          onBack={() => navigate("/photo")}
          onNext={() => navigate("/social-media")}
        />
      </Position>
    </Container>
  );
};

export default Phrase;
